import { initializeFeatureToggleClient } from '@bizzabo/feature-toggle-client';
import namespace from 'config/namespace';

export async function init(eventUniqueName: string, accountId?: number) {
    try {
        const config = createConfig(eventUniqueName, String(accountId));

        return await initializeFeatureToggleClient(config);
    } catch (error) {
        console.error(error);
    }
}

function createConfig(eventUniqueName: string, accountId?: string) {
    return {
        env: !namespace ? 'production' : 'dev',
        customAttributes: {
            eventUniqueName,
            namespace,
            accountId,
        },
    };
}
